import { FromNow } from '@plato/app-shared/components/from-now';
import { Text } from '@plato/ui-legacy/components/ui/text';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import { getDueDateColor, isTaskDueToday, isTaskOverdue } from '../../../utils/task-helpers.ts';

type TaskDueStatusTextProps = {
    task: CrmTaskDTO;
};

/**
 * Text variant for dashboard (no border, just colored text)
 */
export function TaskDueStatusText({ task }: TaskDueStatusTextProps): ReactNode {
    const { t } = useTranslation();

    if (isTaskOverdue(task)) {
        return <Text color={getDueDateColor(task)}>{t('overdue', { ns: 'tasks' })}</Text>;
    }

    if (isTaskDueToday(task)) {
        return <Text color={getDueDateColor(task)}>{t('due_today', { ns: 'tasks' })}</Text>;
    }

    return <FromNow minimumUnit="minute">{task.dueDate}</FromNow>;
}
